var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vue-editor', {
    style: _vm.$vuetify.breakpoint.xs || _vm.$vuetify.breakpoint.mobile ? 'padding-bottom: 190px' : 'padding-bottom: 60px',
    attrs: {
      "id": "editorDescription",
      "value": _vm.description,
      "disabled": "",
      "editor-options": _vm.editorOptions
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }